import { render, staticRenderFns } from "./smsValidationSubscribe.vue?vue&type=template&id=1bc5f920&scoped=true"
import script from "./smsValidationSubscribe.vue?vue&type=script&lang=js"
export * from "./smsValidationSubscribe.vue?vue&type=script&lang=js"
import style0 from "./smsValidationSubscribe.vue?vue&type=style&index=0&id=1bc5f920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5f920",
  null
  
)

export default component.exports